var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo } from "react";
import { Box, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, ModalFooter, Flex, ModalCloseButton, Button, FormControl, FormLabel, Select, FormErrorMessage, Input, } from "@reverb-ui/react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FlexLine } from "../company-owner/flex-line";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
import { useCompanySizes } from "@/shared/hooks/use-company-sizes";
import { useIndustries } from "@/shared/hooks/use-industries";
import { useDocumentTypes } from "@/shared/hooks/use-document-types";
import { useTranslation } from "react-i18next";
import { cnpjMask, cpfMask, formatTextToCNPJ, formatTextToCPF, } from "@/shared/utils";
import MaskedInput from "@/shared/components/masked-input";
function formatData(clientInformation) {
    var documentFormatted = clientInformation.document;
    if (clientInformation.document && clientInformation.documentType) {
        switch (clientInformation.documentType.description) {
            case "CPF":
                documentFormatted = formatTextToCPF(clientInformation.document);
                break;
            case "CNPJ":
                documentFormatted = formatTextToCNPJ(clientInformation.document);
                break;
            default:
                break;
        }
    }
    return {
        companyName: clientInformation.name,
        tradeName: clientInformation.tradeName,
        documentNumber: documentFormatted,
        domain: clientInformation.domain,
        industry: clientInformation.industry
            ? {
                label: clientInformation.industry.description,
                value: clientInformation.industry.id.toString(),
            }
            : null,
        companySize: clientInformation.employeeRange
            ? {
                label: clientInformation.employeeRange.description,
                value: clientInformation.employeeRange.id.toString(),
            }
            : null,
        documentType: clientInformation.documentType
            ? {
                label: clientInformation.documentType.description,
                value: clientInformation.documentType.id.toString(),
            }
            : null,
    };
}
function formatFormDataObjectToClientInput(clientInformation, originalCLientInformation) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var dataLegals = {
        employeeRangeId: +clientInformation.companySize.value,
        industryId: +clientInformation.industry.value,
        tradeName: clientInformation.tradeName,
        logo: (_a = originalCLientInformation.logo) !== null && _a !== void 0 ? _a : undefined,
    };
    var dataIndividuals = originalCLientInformation.birthDate || originalCLientInformation.rg
        ? {
            birthDate: originalCLientInformation.birthDate,
            rg: originalCLientInformation.rg,
        }
        : undefined;
    return {
        rockId: undefined,
        document: clientInformation.documentNumber,
        domain: clientInformation.domain,
        name: clientInformation.companyName,
        dataLegals: dataLegals,
        dataIndividuals: dataIndividuals,
        documentTypeId: +clientInformation.documentType.value,
        segmentationId: (_c = (_b = originalCLientInformation.segmentation) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : undefined,
        isPartner: originalCLientInformation.isPartner,
        locationId: (_e = (_d = originalCLientInformation.location) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : undefined,
        socialNetwork: (_f = originalCLientInformation.socialNetwork) !== null && _f !== void 0 ? _f : undefined,
        partnershipId: (_h = (_g = originalCLientInformation.partnership) === null || _g === void 0 ? void 0 : _g.id) !== null && _h !== void 0 ? _h : undefined,
    };
}
export var ModalCompanyOwnerInformation = function (_a) {
    var isOpen = _a.isOpen, clientInformation = _a.clientInformation, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var t = useTranslation("my-account").t;
    var innerModalOnClose = function () {
        reset(formatData(clientInformation));
        onClose();
    };
    var onSubmitForm = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onSubmit(formatFormDataObjectToClientInput(data, clientInformation))];
                case 1:
                    _a.sent();
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    var _b = useForm({
        defaultValues: formatData(clientInformation),
    }), handleSubmit = _b.handleSubmit, register = _b.register, reset = _b.reset, control = _b.control, _c = _b.formState, errors = _c.errors, isSubmitting = _c.isSubmitting, isSubmitSuccessful = _c.isSubmitSuccessful;
    var useWatchDocumentType = useWatch({
        control: control,
        defaultValue: undefined,
        name: "documentType",
    });
    var documentMask = useMemo(function () {
        if ((useWatchDocumentType === null || useWatchDocumentType === void 0 ? void 0 : useWatchDocumentType.label) === "CPF") {
            return cpfMask;
        }
        if ((useWatchDocumentType === null || useWatchDocumentType === void 0 ? void 0 : useWatchDocumentType.label) === "CNPJ") {
            return cnpjMask;
        }
        return false;
    }, [useWatchDocumentType]);
    var getErrorMessage = function (field) { var _a; return (_a = errors === null || errors === void 0 ? void 0 : errors[field]) === null || _a === void 0 ? void 0 : _a.message; };
    var companySizes = useCompanySizes(true).companySizes;
    var industries = useIndustries(true).industries;
    var documentTypes = useDocumentTypes(true).documentTypes;
    useEffect(function () {
        if (isSubmitSuccessful)
            reset(formatData(clientInformation));
    }, [isSubmitSuccessful]);
    return (React.createElement(Box, { w: "full" },
        React.createElement(Modal, { isOpen: isOpen, onClose: innerModalOnClose, size: "3xl" },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null,
                    t("company-tab.modal-edit-company.edit-company"),
                    React.createElement(ModalCloseButton, null)),
                React.createElement("form", { onSubmit: handleSubmit(onSubmitForm) },
                    React.createElement(ModalBody, { overflow: "auto" },
                        React.createElement(Flex, { flexDirection: "column", justifyContent: "center", w: "100%" },
                            React.createElement(FlexLine, { gap: "20px", h: undefined },
                                React.createElement(FormControl, { isInvalid: getErrorMessage("companyName"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.company-name"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Input, __assign({}, register("companyName", {
                                        required: t("company-tab.modal-edit-company.company-name-required"),
                                    }))),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("companyName")))),
                            React.createElement(FlexLine, { gap: "20px", h: undefined },
                                React.createElement(FormControl, { isInvalid: getErrorMessage("tradeName"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.trade-name"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Input, __assign({}, register("tradeName", {
                                        required: t("company-tab.modal-edit-company.trade-name-required"),
                                    }))),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("tradeName"))),
                                React.createElement(FormControl, { isInvalid: getErrorMessage("companySize"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.company-size"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Controller, { name: "companySize", control: control, rules: {
                                            required: t("company-tab.modal-edit-company.company-size-required"),
                                        }, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Select, __assign({}, field, { options: companySizes, isDisabled: isSubmitting })));
                                        } }),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("companySize")))),
                            React.createElement(FlexLine, { gap: "20px", h: undefined },
                                React.createElement(FormControl, { isInvalid: getErrorMessage("industry"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.industry"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Controller, { name: "industry", control: control, rules: {
                                            required: t("company-tab.modal-edit-company.industry-required"),
                                        }, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Select, __assign({}, field, { options: industries, isDisabled: isSubmitting })));
                                        } }),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("industry"))),
                                React.createElement(FormControl, { isInvalid: getErrorMessage("domain"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.website"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Input, __assign({}, register("domain", {
                                        required: t("company-tab.modal-edit-company.website-required"),
                                    }))),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("domain")))),
                            React.createElement(FlexLine, { gap: "20px", h: undefined },
                                React.createElement(FormControl, { isInvalid: getErrorMessage("documentType"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.document-type"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Controller, { name: "documentType", control: control, rules: {
                                            required: t("company-tab.modal-edit-company.document-type-required"),
                                        }, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Select, __assign({}, field, { options: documentTypes, isDisabled: isSubmitting })));
                                        } }),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("documentType"))),
                                React.createElement(FormControl, { isInvalid: getErrorMessage("documentNumber"), isDisabled: isSubmitting },
                                    React.createElement(FormLabel, null,
                                        t("company-tab.modal-edit-company.document"),
                                        " ",
                                        React.createElement(RequiredIndicator, null)),
                                    React.createElement(Controller, { control: control, name: "documentNumber", rules: {
                                            required: t("company-tab.modal-edit-company.document-required"),
                                        }, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(MaskedInput, __assign({ guide: false, mask: documentMask }, field)));
                                        } }),
                                    React.createElement(FormErrorMessage, null, getErrorMessage("documentNumber")))))),
                    React.createElement(ModalFooter, null,
                        React.createElement(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-end", p: "0", gap: "24px" },
                            React.createElement(Button, { variant: "outline", onClick: innerModalOnClose, isLoading: isSubmitting }, t("company-tab.modal-edit-company.cancel")),
                            React.createElement(Button, { colorScheme: "blue", type: "submit", isLoading: isSubmitting }, t("company-tab.modal-edit-company.save")))))))));
};
